<script lang="jsx">
const Retry = ({ props: { refresh } }) => {
    return (
      <p>
        Something went wrong,{" "}
        <a href="" onClick={e => (e.preventDefault(), refresh())}>
          try again
        </a>
        .
      </p>
    );
};
export default Retry;
</script>
